module.exports = __webpack_public_path__ + "static/img/5bg_2.8f1a993.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_2.png
// module id = 727
// module chunks = 1